import React from 'react';
import moment from "moment";
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import _ from 'lodash';

import useStyles from '../styles';
import images from '../../../../images';
import TextField from '../TextField';
import DateField from '../DateField';
import CurrencyField from '../CurrencyField';
import QuantityField from '../QuantityField';
import SearchField from '../SearchField';
import NonFieldErrors from '../NonFieldErrors';

import {PortfolioManagerResource} from "../../../../utils/api";
import SearchButton from '../../../Buttons/SearchButton/index';
import {displaySuccessSnackBar, displayErrorSnackBar} from "../../../SnackbarProvider/actions";

const calcValue = (qty, price) => _.round(qty * price, 2) || undefined;

export default connect()((props) => {
  const classes = useStyles();

  const {
    handleFormChange,
    asset,
    errors,
    customerId,
    dispatch,
  } = props;

  const [model, setModel] = React.useState({});
  const [lastSearchedISIN, setLastSearchedISIN] = React.useState();

  React.useEffect(() => {
    if (asset) {
      setModel({
        isin: asset.isin,
        name: asset.name,
        custodian: asset.custodian,
        quantity: asset.quantity,
        price: asset.price,
        price_date: asset.price_date && moment(asset.price_date),
        value: asset.value,
        buy_price: asset.buy_price,
        buy_date: asset.buy_date && moment(asset.buy_date),
        updated: asset.updated && moment(asset.updated + 'Z')
      });
    }
  }, [asset]);

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      price_date: model.price_date && moment(model.price_date).format('YYYY-MM-DD'),
      buy_date: model.buy_date && model.buy_date.format('YYYY-MM-DD'),
    });
  }, [model]);

  const handleModelChange = (field) => (event) => {
    // we need store value in local variable cause event.target might be changed when setModel callback will be executed
    const value = event.target.value;
    const newData = {[field]: value};

    if (field === 'quantity'){
      newData.value = calcValue(value, model.price)
    } else if (field === 'price'){
      newData.value = calcValue(model.quantity, value)
    }

    setModel((prevState) => ({
      ...prevState,
      ...newData,
    }))
  };

  const handleDateChanged = (field) => (value) => {
    setModel((prevState) => ({
      ...prevState,
      [field]: value
    }))
  };

  const handleGetAssetInfo = () => {
    if (customerId && model && model.isin) {
      PortfolioManagerResource.at(`customer/${customerId}/asset-info/?isin=${model.isin}`).get()
      .then((response) => {
        setModel((prevState) => ({
          ...prevState,
          ...response,
          value: calcValue(model.quantity, response.price),
        }));

        setLastSearchedISIN(model.isin);

        dispatch(displaySuccessSnackBar('Das Produkt wurde gefunden. Die entsprechenden Daten wurden vorbefüllt.'))
      })
      .catch((error) => {
        let errorMsg = 'Die Wertpapierinformationen konnten nicht abgeglichen werden.';

        if(_.get(error, 'status') === 404){
          errorMsg = 'Die ISIN wurde leider nicht gefunden.';
        }

        dispatch(displayErrorSnackBar(errorMsg))
      });
    }
  };


  return (
    <Grid container className={classes.formContainer} id='asset-form-modal-tour-element'>
      <Grid item className={classes.formBody}>
        <div className={classes.formHeader}>
          <div>
          <img src={images.asset_icons.external_icon_white} alt="External"/>
          </div>
          <p>Wertpapiere</p>
        </div>

        <div>
          <SearchField
            label="ISIN"
            error={errors && errors.isin}
            helperText={model.isin && model.isin !== lastSearchedISIN && 'Das Wertpapier wurde noch nicht abgeglichen.'}
            value={model.isin}
            onChange={handleModelChange('isin')}
            endAdornment={
              <SearchButton
                classes={{
                  searchButton: classes.labelButton
                }}
                icon={<i className={"fa fa-search"} />}
                text="Suche starten"
                onValueApprove={handleGetAssetInfo}
                isSearchDisabled={!model.isin || model.isin.length < 3} //as cios need at least 3 characters
              />
            }
          />
          <TextField
            label="Name / Bezeichnung"
            error={errors && errors.name}
            value={model.name}
            onChange={handleModelChange('name')}
          />
          <TextField
            label="Bank / Depotstelle"
            error={errors && errors.custodian}
            value={model.custodian}
            onChange={handleModelChange('custodian')}
          />
          <QuantityField
            label="Anteile"
            error={errors && errors.quantity}
            value={model.quantity}
            onChange={handleModelChange('quantity')}
          />
          <CurrencyField
            label="Kurs"
            error={errors && errors.price}
            value={model.price}
            onChange={handleModelChange('price')}
          />
          <DateField
            label="Kursdatum"
            maxDate={moment()}
            value={model.price_date}
            error={errors && errors.price_date}
            onChange={handleDateChanged('price_date')}
          />
          <CurrencyField
            label="Wert"
            error={errors && errors.value}
            value={model.value}
            onChange={handleModelChange('value')}
            disabled
          />
          <CurrencyField
            label="Einstandswert"
            value={model.buy_price}
            error={errors && errors.buy_price}
            onChange={handleModelChange('buy_price')}
          />
          <DateField
            label="Einstandsdatum"
            maxDate={moment()}
            value={model.buy_date}
            error={errors && errors.buy_date}
            onChange={handleDateChanged('buy_date')}
          />
          <DateField
            label="Stand vom"
            value={model.updated || moment()}
            disabled={true}
          />
          {errors && errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
        </div>
      </Grid>
    </Grid>
  )
})